export default __webpack_public_path__ + "static/media/ID_LIV.39f5bf10.jpg";